"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = require("@lt/components/icons-react/userflow");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LocationIcon = (0, _styledComponents["default"])(_userflow.SearchLocation).withConfig({
  displayName: "styles__LocationIcon",
  componentId: "sc-bknwm8-0"
})(["width:16px;height:16px;"]);
exports.LocationIcon = LocationIcon;